import React, { useEffect, useState } from "react";
import api from "../api";
import downloadIcon from "../assets/Images/Download.png";
import filterIcon from "../assets/Images/Filter.png";
import addIcon from "../assets/Images/AddIcon.png";
import conversationIcon from "../assets/icons/chatIcon.png";
import viewIcon from "../assets/Images/View.png";
import editIcon from "../assets/Images/Edit.png";
import changeStatusIcon from "../assets/Images/ChangeStatus.png";
import { formatDateToUserTimeZone } from "../utils/formatDate";
import { useNavigate } from "react-router-dom";
import TopTitleBar from "./TopTitleBar";

const CONVERSATION_API_URL = process.env.REACT_APP_API_URL;

const ConversationManagement = () => {
  const [conversations, setConversations] = useState([]);
  const [conversationStats, setConversationStats] = useState({
    total: 0,
    active: 0,
    completed: 0,
    flagged: 0,
  });

  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [sortOrder, setSortOrder] = useState("desc");
  const [dayFilter, setDayFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const fetchConversations = async () => {
    try {
      const res = await api.get(
        `${CONVERSATION_API_URL}/users/conversation-summary`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setConversations(res.data || []);
      setTotalEntries(res.data?.length || 0);
    } catch (err) {
      console.error("Failed to fetch enterprise conversation stats:", err);
    }
  };

  const fetchStats = async () => {
    try {
      const res = await api.get(`${CONVERSATION_API_URL}/chat/stats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setConversationStats(res.data);
      // console.log(res.data);
    } catch (err) {
      console.error("Failed to fetch conversation stats:", err);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  useEffect(() => {
    fetchConversations();
  }, [searchTerm, entriesPerPage, sortOrder, dayFilter, currentPage]);

  const handleEntriesChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleReset = () => {
    setSearchTerm("");
    setSortOrder("desc");
    setDayFilter("");
    setCurrentPage(1);
  };

  const handleApply = () => {
    fetchConversations();
  };

  const exportExcel = async () => {
    try {
      const res = await api.get(`${CONVERSATION_API_URL}/export`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "conversations.xlsx");
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.error("Failed to export:", err);
    }
  };

  const handleView = (item) => {
    console.log("View clicked:", item);
  };

  const handleEdit = (item) => {
    console.log("Edit clicked:", item);
  };

  const handleChangeStatus = (item) => {
    console.log("Change status clicked:", item);
  };

  // Pagination
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  const showingFrom =
    totalEntries === 0 ? 0 : (currentPage - 1) * entriesPerPage + 1;
  const showingTo = Math.min(currentPage * entriesPerPage, totalEntries);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="mx-2 pt-1 h-100">
      {/* Stats Boxes */}
      <div className="d-flex flex-wrap gap-3 mb-0  justify-content-evenly align-items-stretch">
        {[
          {
            label: "Total Conversations",
            value: conversationStats?.session?.total || 0,
          },
          {
            label: "Active Conversations",
            value: conversationStats?.session?.active || 0,
          },
          {
            label: "Completed Conversations",
            value: conversationStats?.session?.completed || 0,
          },
        ].map((box, index) => (
          <div className="dashboard-box p-3 rounded shadow-sm" key={index}>
            <div className="d-flex align-items-center mb-2">
              <img
                src={conversationIcon}
                alt={box.label}
                style={{
                  width: "24px",
                  height: "24px",
                }}
                className="icon-image1"
              />
              <h6 className="ms-2 mb-0">{box.label}</h6>
            </div>
            <h2 className="fw-bold">{box.value}</h2>
          </div>
        ))}
      </div>

      {/* <div className="d-flex justify-content-between align-items-center mb-2 mt-1 ">
        <span className="fw-bold" style={{ fontSize: "20px" }}>
          Conversation Management Details 
        </span>
      </div> */}

      <TopTitleBar level="conversation" />

      {/* Filters & Search */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex align-items-center">
          <select
            className="form-select w-auto"
            value={entriesPerPage}
            onChange={handleEntriesChange}
          >
            {[50, 100, 500].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          <label className="ms-2 mt-2">Entries per page</label>
        </div>

        <div className="d-flex align-items-center">
          <div className="custom-search-wrapper me-3">
            <div className="input-group custom-search-group">
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search Conversations"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          {/* 
          <button
            className="btn btn-outline-secondary me-2 action-button"
            onClick={exportExcel}
            title="Export to Excel"
          >
            <img src={downloadIcon} className="icon-image" alt="Download" />
          </button> */}

          <div className="">
            <button
              className="icon-button filter-dropdown-toggle action-button"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title="Filter"
            >
              <img src={filterIcon} className="icon-image" alt="Filter" />
            </button>

            <div
              className="dropdown-menu profile-menu-dropdown p-2"
              style={{ minWidth: "200px" }}
            >
              <h6 className="fw-bolder refresh-prompts">Time</h6>
              <hr className="mt-0" />
              {["asc", "desc"].map((order) => (
                <div className="form-check" key={order}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="sortOrder"
                    id={order}
                    value={order}
                    checked={sortOrder === order}
                    onChange={() => setSortOrder(order)}
                  />
                  <label
                    className="form-check-label notification-label"
                    htmlFor={order}
                  >
                    {order === "asc" ? "Ascending" : "Descending"}
                  </label>
                </div>
              ))}

              <hr />
              <h6 className="fw-bolder refresh-prompts">By Day</h6>
              <hr className="mt-0" />
              {["Today", "Yesterday", ""].map((day) => (
                <div className="form-check" key={day || "all"}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="dayFilter"
                    id={day || "all"}
                    value={day}
                    checked={dayFilter === day}
                    onChange={() => setDayFilter(day)}
                  />
                  <label
                    className="form-check-label fw-5"
                    htmlFor={day || "all"}
                  >
                    {day || "All"}
                  </label>
                </div>
              ))}

              <div className="d-flex justify-content-between mt-3">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  className="btn dropdown-btn bg-dark text-white btn-sm"
                  onClick={handleApply}
                >
                  Apply Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      {totalEntries === 0 ? (
        <div className="text-center my-5">
          <p className="text-muted fs-5">No entries found.</p>
        </div>
      ) : (
        <div className="not-disable">
          <div className="table-responsive">
            <table className="table conversation-table1 table-sm w-100">
              <thead>
                <tr>
                  <th>Enterprize Name</th>
                  <th className="text-center">Total Users</th>
                  <th className="text-center">Total Conversations</th>
                  <th className="text-center">Total Messages</th>
                  <th className="text-center">Total Models Used</th>
                  <th>Uploaded on</th>
                  {/* <th>Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {conversations.map((item) => (
                  <tr key={item.enterprise_id}>
                    <td
                      title={item.enterprise_name}
                      style={{
                        maxWidth: "190px",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                    >
                      {item.enterprise_name}
                    </td>
                    <td className="text-center">
                      {item.total_users > 0 ? (
                        <span
                          className="text-primary text-decoration-none"
                          role="button"
                          onClick={() =>
                            navigate("/admin/chat-usage-management", {
                              state: { enterprise: item },
                            })
                          }
                        >
                          {item.total_users}
                        </span>
                      ) : (
                        "0"
                      )}
                    </td>

                    <td className="text-center">
                      {item.total_conversations > 0 ? (
                        <span
                          className="text-primary text-decoration-none"
                          role="button"
                          onClick={() =>
                            navigate("/admin/chat-usage-management", {
                              state: { enterprise: item },
                            })
                          }
                        >
                          {item.total_conversations}
                        </span>
                      ) : (
                        "0"
                      )}
                    </td>
                    <td className="text-center">
                      {item.total_messages > 0 ? (
                        <span
                          className="text-primary text-decoration-none"
                          role="button"
                          onClick={() =>
                            navigate("/admin/chat-usage-management", {
                              state: { enterprise: item },
                            })
                          }
                        >
                          {item.total_messages}
                        </span>
                      ) : (
                        "0"
                      )}
                    </td>
                    <td className="text-center">
                      {item.total_models_used > 0 ? (
                        <span
                          className="text-primary text-decoration-none"
                          role="button"
                          onClick={() =>
                            navigate("/admin/chat-usage-management", {
                              state: { enterprise: item },
                            })
                          }
                        >
                          {item.total_models_used}
                        </span>
                      ) : (
                        "0"
                      )}
                    </td>

                    <td>
                      {item.last_updated &&
                      new Date(item.last_updated).getTime() !== 0
                        ? formatDateToUserTimeZone(item.last_updated)
                        : "-"}
                    </td>

                    {/* <td>
                      <button
                        className="icon-button"
                        onClick={() => handleView(item)}
                        title="View"
                      >
                        <img src={viewIcon} alt="View" />
                      </button>
                      <button
                        className="icon-button"
                        onClick={() => handleEdit(item)}
                        title="Edit"
                      >
                        <img src={editIcon} alt="Edit" />
                      </button>
                      <button
                        className="icon-button"
                        onClick={() => handleChangeStatus(item)}
                        title="Change Status"
                      >
                        <img src={changeStatusIcon} alt="Change Status" />
                      </button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination Footer */}
          <div className="d-flex fixed-bottom-footer bgcolor justify-content-between align-items-center mt-2 table-footer">
            <div className="refresh-prompts">
              Showing {showingFrom} to {showingTo} of {totalEntries} entries
            </div>
            <nav>
              <ul className="pagination mb-0">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(1)}
                  >
                    <i className="bi bi-chevron-double-left"></i>
                  </button>
                </li>
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(currentPage - 1)}
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </li>
                {pageNumbers.map((num) => (
                  <li
                    key={num}
                    className={`page-item ${
                      num === currentPage ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageClick(num)}
                    >
                      {num}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(currentPage + 1)}
                  >
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </li>
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(totalPages)}
                  >
                    <i className="bi bi-chevron-double-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConversationManagement;
